<template>
	<v-dialog v-model="dialog" max-width="500px" persistent>
		<v-card>
			<DialogError ref="error"/>
			<v-progress-linear v-show="loading" indeterminate/>
			<v-card-title>Link Virtual Integration</v-card-title>
			<v-card-text>
				<v-text-field
					v-model="token"
					label="Token"
					placeholder="Paste your token here"
					outlined
					:rules="tokenRules"
				></v-text-field>
			</v-card-text>
			<v-card-actions>
				<v-btn text :disabled="loading" @click="cancel">Cancel</v-btn>
				<v-spacer/>
				<v-btn color="primary" :disabled="!isTokenValid || loading" @click="install">Link</v-btn>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
import DialogError from '@/components/util/DialogError';

export default {
	name: "VirtualIntegrationDialog",

	components: {
		DialogError
	},

	props: {
		visible: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		dialog: {
			get() {
				return this.visible;
			},
			set(value) {
				if (!value) {
					this.$emit('close');
				}
			}
		},
		isTokenValid() {
			return this.token && this.token.trim().length > 0;
		}
	},

	methods: {
		async install() {
			this.loading = true;
			try {
				await this.$store.dispatch('configuration/installIntegration', {
					virtual: this.token
				});

				this.token = '';
				this.$emit('close');
				this.$emit('installed');
			} catch(e) {
				console.error(e);
				this.$refs.error.show('Could not link virtual integration. Please try again later.');
			} finally {
				this.loading = false;
			}
		},
		cancel() {
			this.token = '';
			this.$emit('close');
		}
	},

	data: () => ({
		token: '',
		loading: false,
		tokenRules: [
			v => !!v || 'Token is required'
		]
	})
};
</script>